// PublicDownloadLink.jsx
import React from 'react';

const PublicDownloadLink = ({ filePath }) => {
  // filePath example: "uploads/files/debd2319-7a48-4eda-a05a-9181574cfcd8.pdf"
  const BASE = process.env.REACT_APP_API_URL || ''; // e.g. https://example.com/
  const url = `${BASE}${filePath.startsWith('/') ? filePath.slice(1) : filePath}`;

  return (
    <a href={url} download target="_blank" rel="noopener noreferrer">
      Download file
    </a>
  );
};

export default PublicDownloadLink;
